import { createContext } from 'react';

// https://devdocs.magento.com/guides/v2.4/graphql/tutorials/checkout/checkout-shopping-cart.html
// https://devdocs.magento.com/guides/v2.4/graphql/queries/cart.html

export interface IOldCartContext {
    isQuickCartVisible: boolean;
    setQuickCartVisible: (visible: boolean) => void;
}


export const OldCartContext = createContext<IOldCartContext>(
    // We don't really want a default value, but createContext requires one,
    // and TypeScript expect it to have correct type.
    undefined as unknown as IOldCartContext
);
